var React = require('react');

function ClearIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M10.846 0L5.909 4.937.972 0 0 .957l4.937 4.937L0 10.83l.972.973L5.91 6.866l4.937 4.937.957-.973-4.937-4.936L11.803.957z"}));
}

ClearIcon.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = ClearIcon;

ClearIcon.default = ClearIcon;
